module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vheader"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('ul', [_c('li', {
    class: {
      active: _vm.$route.name == 'intro'
    }
  }, [_c('a', {
    attrs: {
      "href": "/intro"
    }
  }, [_vm._v("项目介绍")])]), _c('li', {
    class: {
      active: _vm.$route.name == 'news'
    }
  }, [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("前沿动态")])]), _c('li', {
    class: {
      active: _vm.$route.name == 'entry'
    }
  }, [_c('a', {
    attrs: {
      "href": "/entry"
    }
  }, [_vm._v("会员申请")])]), _c('li', {
    class: {
      active: _vm.$route.name == 'en'
    }
  }, [_c('a', {
    attrs: {
      "href": "/en"
    }
  }, [_vm._v("En")])])]), _c('img', {
    staticClass: "navBtn",
    attrs: {
      "src": _vm.navSrc()
    },
    on: {
      "click": function($event) {
        return _vm.navClick()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/imgs/header-logo-m.png"),
      "alt": "前沿社"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-015d68d7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vheader.vue
// module id = 186
// module chunks = 1